import * as API from '..'
export default {
  // 文件信息保存
  informationSave: params => {
    return API.POST(process.env.baseSysURL+'/project/information/save',params)
  },

  // 文件信息更新
  informationUpdate: params => {
    return API.POST(process.env.baseSysURL+'/project/information/update',params)
  },

  // 文件信息列表查询
  getInformationList: params => {
    return API.POST(process.env.baseSysURL+'/project/information/list',params)
  },

  // 文件信息 设置状态
  setInformationStatus: params => {
    return API.POST(process.env.baseSysURL+'/project/information/set/status',params)
  },

  // 文件信息 延迟截止日期
  setInformationEndTime: params => {
    return API.POST(process.env.baseSysURL+'/project/information/set/endTime',params)
  },

  // 文件信息 删除
  informationDelete: params => {
    return API.POST(process.env.baseSysURL+'/project/information/delete',params)
  },

  // 文件信息详细信息查询
  getInformationDetail: params => {
    return API.POST(process.env.baseSysURL+'/project/information/detail',params)
  },

  // 项目配置 批量保存
  configSave: params => {
    return API.POST(process.env.baseSysURL+'/project/config/batchSave',params)
  },

  // 项目配置 批量更新
  configUpdate: params => {
    return API.POST(process.env.baseSysURL+'/project/config/batchUpdate',params)
  },

  // 项目配置 列表查询
  getConfigList: params => {
    return API.POST(process.env.baseSysURL+'/project/config/list',params)
  },

  // 标题信息查询
  getTitleList: params => {
    return API.POST(process.env.baseSysURL+'/project/information/titile/list',params)
  },

  // 项目申报列表查询
  getRecordListManger: params => {
    return API.POST(process.env.baseSysURL+'/project/record/list',params)
  },

  // 项目申报 详细信息
  getRecordDetail: params => {
    return API.POST(process.env.baseSysURL+'/project/record/detail',params)
  },

  // 申报记录日志列表查询
  getRecordLog: params => {
    return API.POST(process.env.baseSysURL+'/project/log/list',params)
  },

  // 申报记录 审核或拒绝
  recordCheck: params => {
    return API.POST(process.env.baseSysURL+'/project/record/check',params)
  },

  // 申报记录统计
  getRecordNumber: params => {
    return API.POST(process.env.baseSysURL+'/project/record/stat/status/count',params)
  },

  // 项目统计-按照区划统计
  getRecordCount: params => {
    return API.POST(process.env.baseSysURL+'/project/stat/area/record/count',params)
  },

  // 项目统计-按照区划统计列表查询
  getRecordList: params => {
    return API.POST(process.env.baseSysURL+'/project/stat/area/record/list',params)
  },

  // 项目统计-按照区划统计列表查询EXCEL导出
  getRecordExport: params => {
    return API.POSTBLOB(process.env.baseSysURL+'/project/stat/area/record/excel/export',params)
  },

  // 项目统计-按照项目统计
  getProjectList: params => {
    return API.POST(process.env.baseSysURL+'/project/stat/project/record/count',params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_project/api_project.js